module.exports = __webpack_public_path__ + "static/media/pcariMainToolBarLogo.f29e23f2.svg";